import { getApiActionTypes } from '../../../../shared/store/storeHelpers';

export const SELECT_JURISDICTION_ID = 'SELECT_JURISDICTION_ID';

export const fetchJurisdictionsTypes = getApiActionTypes('FETCH_JURISDICTIONS');
